export const VOTE_VALUES: Array<0 | 0.5 | 1 | 2 | 3 | 5 | 8 | 13 | 20 | 40 | 100 | "?"> = [
  0, 0.5, 1, 2, 3, 5, 8, 13, 20, 40, 100, "?",
];

// Use relative URLs in production (same origin) or environment variables if provided
// In development, Vite proxy handles routing to backend
// This allows the app to work with any domain/ingress configuration
const getBaseUrl = () => {
  // Allow override via environment variable
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  // Use relative URL (works in both dev with proxy and production)
  // In development, Vite proxy forwards /api to http://localhost:3000
  // In production, backend serves frontend, so same origin
  return '';
};

export const API_BASE_URL = getBaseUrl();
// WebSocket URL: use relative in browser (proxy handles it in dev, same origin in prod)
// Or override with environment variable
export const WS_URL = import.meta.env.VITE_WS_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');

